export default "__VITE_ASSET__BUBfELi5__"